import { render } from "./SendRecipeSettingsToPLCs.vue?vue&type=template&id=675291f0&scoped=true"
import script from "./SendRecipeSettingsToPLCs.vue?vue&type=script&lang=js"
export * from "./SendRecipeSettingsToPLCs.vue?vue&type=script&lang=js"

import "./SendRecipeSettingsToPLCs.vue?vue&type=style&index=0&id=675291f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675291f0"]])

export default __exports__